import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { HowItWorksPage } from "./pages/HowItWorksPage";
import { ServicesPage } from "./pages/ServicesPage";
import { PricingPage } from "./pages/PricingPage";
import { PartnersPage } from "./pages/PartnersPage";
import { FAQPage } from "./pages/FAQPage";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";

// Simple placeholder for Privacy and Terms pages
const PrivacyPage = () => (
  <div className="min-h-screen bg-[#0F0F0F] pt-32 pb-24">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <h1 className="font-serif text-4xl text-white mb-8">Privacy Policy</h1>
      <div className="prose prose-invert prose-neutral">
        <p className="text-neutral-400">
          This is a placeholder for the Privacy Policy. The actual policy content 
          will be added here based on legal requirements and company policies.
        </p>
      </div>
    </div>
  </div>
);

const TermsPage = () => (
  <div className="min-h-screen bg-[#0F0F0F] pt-32 pb-24">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <h1 className="font-serif text-4xl text-white mb-8">Terms of Service</h1>
      <div className="prose prose-invert prose-neutral">
        <p className="text-neutral-400">
          This is a placeholder for the Terms of Service. The actual terms content 
          will be added here based on legal requirements and company policies.
        </p>
      </div>
    </div>
  </div>
);

function App() {
  return (
    <div className="App bg-[#0F0F0F] min-h-screen">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
